module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/icon_deli-b4fa40adeb081c884d45aa3d3eefe8b9.png";